module.exports = __webpack_public_path__ + "static/d12-bc32664ee4f114ccb293856e9effeb57.png";